import React from 'react';

const AdminQuestionsToolbar = ({
  searchQuery,
  onSearchChange,
  filterAssessmentType,
  onFilterAssessmentTypeChange,
  filterCategory,
  onFilterCategoryChange,
  categories,
  filterIndustry,
  onFilterIndustryChange,
  uniqueIndustries,
  onAddClick
}) => (
  <div className="p-6 border-b border-gray-200 dark:border-gray-700">
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-4 gap-4">
          <input
            type="text"
            placeholder="Search questions or codes..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
          />
          <select
            value={filterAssessmentType}
            onChange={(e) => onFilterAssessmentTypeChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            <option value="all">All Assessment Types</option>
            <option value="ESA">ESA</option>
            <option value="EMHA">EMHA</option>
          </select>
          <select
            value={filterCategory}
            onChange={(e) => onFilterCategoryChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat === 'all' ? 'All Categories' : cat}
              </option>
            ))}
          </select>
          <select
            value={filterIndustry}
            onChange={(e) => onFilterIndustryChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          >
            <option value="all">All Industries</option>
            {uniqueIndustries.map((ind) => (
              <option key={ind.id} value={ind.id}>
                {ind.displayName}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={onAddClick}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-600"
        >
          <span className="mr-2">+</span>
          Add New Question
        </button>
      </div>
    </div>
  </div>
);

export default AdminQuestionsToolbar;


